// extracted by mini-css-extract-plugin
export var chevronIcon = "_8k-2";
export var teamName = "_8k-1";
export var teamSwitcherButton = "_8k-0";